import { cn } from "@nfp-tracker/utils";
import { Badge } from "../ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

type LifetimeDiscountBadgeProps = {
  className?: string;
  tooltipText?: string;
};

export const LifetimeDiscountBadge = ({
  className,
  tooltipText = "Thank you for joining our waitlist! This account gets an automatic $20 savings on annual billing.",
}: LifetimeDiscountBadgeProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-help">
          <Badge
            variant="outline"
            className={cn(
              "border-amber-500/60 bg-amber-100 text-amber-900 dark:border-amber-400/50 dark:bg-amber-500/15 dark:text-amber-300",
              className
            )}
          >
            Lifetime Discount
          </Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-center">
        <p>{tooltipText}</p>
      </TooltipContent>
    </Tooltip>
  );
};
